var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.554 7.79639C20.005 7.79639 22 9.85618 22 12.3878V17.4201C22 19.9456 20.01 22.0002 17.564 22.0002L6.448 22.0002C3.996 22.0002 2 19.9414 2 17.4098V12.3775C2 9.85205 3.991 7.79639 6.438 7.79639H7.378L17.554 7.79639Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5462 16.5374L15.4552 13.5695C15.7552 13.2627 15.7552 12.7691 15.4532 12.4634C15.1512 12.1587 14.6642 12.1597 14.3642 12.4654L12.7712 14.0905L12.7712 3.7821C12.7712 3.35042 12.4262 3 12.0002 3C11.5752 3 11.2312 3.35042 11.2312 3.7821L11.2312 14.0905L9.63718 12.4654C9.33718 12.1597 8.85018 12.1587 8.54818 12.4634C8.39718 12.6168 8.32118 12.8168 8.32118 13.018C8.32118 13.217 8.39718 13.4171 8.54618 13.5695L11.4552 16.5374C11.6002 16.6847 11.7962 16.768 12.0002 16.768C12.2052 16.768 12.4012 16.6847 12.5462 16.5374Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperDownload);
export default __webpack_public_path__ + "static/media/paper-download.021c7ba0cd16ba56528b218284c56d33.svg";
export { ForwardRef as ReactComponent };